module.exports = __webpack_public_path__ + "img/graph1.8f45d625.svg";